import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    instruksi: "",
    question: "",
    list_journey: "",
    result: "",
    route: null,
    err: "",
  },
  mutations: {
    GET_INSTRUKSI(state, data) {
      state.instruksi = data;
    },
    GET_QUESTION(state, data) {
      state.question = data;
    },
    GET_JOURNEY(state, data) {
      state.list_journey = data;
    },
    GET_ROUTE(state, data) {
      state.list_journey = data;
    },
    RESULT(state, data) {
      state.result = data;
    },
    ERR_MSG(state, data) {
      state.err = data;
    },
  },
  actions: {
    listJourney(context) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        axios
          .get(`${env}/misi/all`)
          .then((res) => {
            let data = res.data;
            context.commit("GET_JOURNEY", data.data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },

    instruksi(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        axios
          .get(`${env}/misi/instruksi/${data}`)
          .then((res) => {
            let data = res.data;
            context.commit("GET_INSTRUKSI", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },

    question(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        let id = data.id;
        let page = data.page;
        axios
          .get(`${env}/misi/pertanyaan/${id}?page=${page}`)
          .then((res) => {
            let data = res.data;
            context.commit("GET_QUESTION", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    getRoute(context) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        axios
          .get(`${env}/misi/skill/kode`)
          .then((res) => {
            let data = res.data;
            context.commit("GET_ROUTE", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },

    postAnswer(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        let id = data.id;
        let body = data.body;
        axios
          .post(`${env}/misi/hasil/misi/${id}`, body)
          .then((res) => {
            let data = res.data;
            context.commit("RESULT", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    register(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        axios
          .post(`${env}/register`, data)
          .then((res) => {
            let data = res.data;
            context.commit("RESULT", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    postJourney(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        let id = data.id;
        let body = data.body;
        let config = {
          // header token
          headers: {
            Authorization: `Bearer ${data.token}`,
          },
        };
        axios
          .post(`${env}/misi/simpan-jawaban/${id}`, body, config)
          .then((res) => {
            let data = res.data;
            context.commit("RESULT", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    dataJurusan(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_JURUSAN;
        let paging = `page[number]=1&page[size]=15`;
        let filter = "";
        let search = "";
        let pageNumber = "";
        let url = `${env}/jurusan`;
        if (data) {
          if (data.filter !== undefined) {
            filter = data.filter !== undefined ? data.filter : "";
            url = `${url}?sort=+kategori_jurusan_id&filter[kategori_jurusan_id]=${filter}`;
          }
          if (data.search !== undefined) {
            search = data.search !== undefined ? data.search : "";
            url = `${url}?filter[search]=${search}`;
          }
          if (data.pageNumber !== undefined) {
            pageNumber = data.pageNumber !== undefined ? data.pageNumber : "1";
            url = `${url}?page[number]=${pageNumber}&page[size]=15`;
          }
        } else {
          url = `${url}?${paging}`;
        }
        axios
          .get(url)
          .then((res) => {
            let data = res.data;
            context.commit("RESULT", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    detailJurusan(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_JURUSAN;
        let id = data.id;
        axios
          .get(`${env}/jurusan?page[size]=1&filter[id]=${id}`)
          .then((res) => {
            let data = res.data;
            context.commit("RESULT", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    submitFormKatalog(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        axios
          .post(`${env}/katalog/submit`, data)
          .then((res) => {
            let data = res.data;
            context.commit("RESULT", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    clickKatalog(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        axios
          .post(`${env}/katalog/clicked`, data)
          .then((res) => {
            let data = res.data;
            context.commit("RESULT", data);
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    getApi(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        axios
          .get(`${env}/${data.path}`)
          .then((res) => {
            let data = res.data;
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
    postApi(context, data) {
      return new Promise((resolve, reject) => {
        let env = process.env.VUE_APP_ENV;
        axios
          .post(`${env}/${data.path}`, data.body)
          .then((res) => {
            let data = res.data;
            resolve(data);
          })
          .catch((error) => {
            context.commit("ERR_MSG", error);
            reject(error);
          });
      });
    },
  },
  modules: {},
});
